import { render } from "./StrategiesMain.vue?vue&type=template&id=32119e3c&scoped=true&lang=true"
import script from "./StrategiesMain.vue?vue&type=script&lang=js"
export * from "./StrategiesMain.vue?vue&type=script&lang=js"

import "./StrategiesMain.vue?vue&type=style&index=0&id=32119e3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32119e3c"

export default script